<template>
  <b-modal
    id="templateModal"
    ref="templateModal"
    title="テンプレート一覧"
    @hide="hide"
    size="lg"
    modal-class="template-modal"
    hide-footer
  >
    <div v-if="hasContactAuthority">
      <div class="ibox-body">
        <ListMessageTemplate
          :isDragDisabled="isDragDisable"
          @createTemplate="openEditTemplate(null)"
        >
          <template #actions="{template}">
            <div class="d-flex actions justify-content-center">
              <button
                class="action-btn font-25"
                @click="openEditTemplate(template)"
                title="Edit"
                style="margin-right: 8px;"
              >
                <img
                  :src="require('@/assets/images/pencil.svg')"
                  alt="編集"
                  class="icon-label"
                />
              </button>
              <button
                class="action-btn font-25"
                title="Delete"
                @click="openDeleteModal(template._id)"
              >
                <img
                  :src="require('@/assets/images/dustbin.svg')"
                  alt="削除"
                  class="icon-label"
                />
              </button>
            </div>
          </template>
        </ListMessageTemplate>
      </div>

      <ConfirmationModal
        ref="confirmationModal"
        :fromMessageTemplate="true"
        :message="confirmationMessage"
        :modal_data="modalData"
        @cancel="closeDeleteModal"
        @confirm-delete="deleteMailTemplate"
      />

      <EditMessageTemplate
        v-if="showEditTemplateModal"
        :showEditTemplateModal="showEditTemplateModal"
        :editModalData="editModalData"
        @close="closeEditModal"
      />
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DeleteModal from './DeleteModal.vue';
import ApiService from '@/service/apiService';
import Api from '@/config/api';
import ListMessageTemplate from './ListMessageTemplate.vue';
import ConfirmationModal from '../../../utils/ConfirmationModal.vue';
import EditMessageTemplate from './EditMessageTemplate.vue';

export default {
  name: 'MailTemplate',
  components: {
    DeleteModal,
    ListMessageTemplate,
    ConfirmationModal,
    EditMessageTemplate,
  },
  data() {
    return {
      showDeleteModal: false,
      isDragDisable: false,
      modalData: {},
      editModalData: {},
      showEditTemplateModal: false,
      errors: [],
    };
  },
  computed: {
    ...mapGetters([
      'getAllMessageTemplates',
      'getAllFlashMessages',
      'getCurrentUser',
    ]),
    hasContactAuthority() {
      return (
        this.getCurrentUser &&
        this.getCurrentUser.companyContactAuthority
      );
    },
    confirmationMessage() {
      return 'このテンプレートを削除しますか？';
    },
  },
  methods: {
    ...mapActions([
      'loadAllMessageTemplates',
      'removeFlashMessage',
      'addFlashMessages',
      'removeAllFlashMessages',
    ]),
    show() {
      this.$refs.templateModal.show();
    },
    hide() {
      this.$refs.templateModal.hide();
    },
    openEditTemplate(template = null) {
      if (template !== null) {
        this.editModalData = template;
      } else {
        this.editModalData = null;
      }
      this.showEditTemplateModal = true;
      // console.log(template);
      // this.$refs.editMessageTemplate.show();
    },
    closeEditModal() {
      this.editModalData = {};
      this.showEditTemplateModal = false;
      // this.$refs.editMessageTemplate.hide();
    },
    openDeleteModal(id) {
      this.modalData = { id };
      this.showDeleteModal = true;
      this.$refs.confirmationModal.show();
    },
    closeDeleteModal() {
      this.modalData = {};
      this.showDeleteModal = false;
      this.$refs.confirmationModal.hide();
    },
    async deleteMailTemplate(id) {
      try {
        let res = await ApiService.delete(
          Api.endpoints.DELETE_MESSAGE_TEMPLATE(id)
        );
        await this.loadAllMessageTemplates();

        this.addFlashMessages([
          { message: res.data.data.success, type: 'success' },
        ]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
      } catch (err) {
        // console.log(err);
        this.errors = [];
        this.parseErrorResponse(err.response);
        this.addFlashMessages([{ message: this.errors[0], type: 'danger' }]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
      }
      this.closeDeleteModal();
      // scroll to top
      window.scrollTo(0, 0);
    },
  },
  watch: {
    getCurrentUser(newVal) {
      if (newVal !== null) {
        if (!this.hasContactAuthority) {
          return this.$router.push('/applicant');
        }
      }
    },
  },
  async mounted() {
    // //   console.log(this.isDragDisable);
    // if (this.getCurrentUser && !this.hasContactAuthority) {
    //   return this.$router.push('/applicant');
    // }
    this.changeBodyBackground();
  },
};
</script>

<style scoped>
>>> .modal-body {
  padding: 0px;
  background-color: #ffff;
}
>>> .modal-header {
  border-bottom: none;
  background-color: #ffff;
}
>>> .modal-footer {
  justify-content: center !important;
  gap: 40px;
  background-color: #fff;
  border-top: none;
}
.btn-action {
  width: 165px;
  height: 50px;
  border-radius: 30px;
  /* padding: 6px; */
}

.action-btn {
  border: none !important;
  background-color: transparent !important;
  color: #787878 !important;
}

.font-25 {
  font-size: 25px !important;
}
.page-heading {
  padding: 20px 5px 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-heading .page-title {
  font-size: 22px;
  margin-bottom: 0;
}

.add-template .btn {
  padding: 0.45rem 1.25rem !important;
  min-width: 0;
}

.page-content {
  margin-top: 5px;
}

.ibox {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* .ibox-body {
    padding: 15px;
  }
   */
.font-16 {
  font-size: 16px !important;
}

.actions .btn-sm {
  border-radius: 0 !important;
  padding: 0 8px;
  min-width: 0;
}

.actions .btn-sm .icon {
  height: 20px;
  width: 20px;
}
</style>
